// Translation: Account > Settings > Phone number (Turkish)
export default Object.freeze({
	form: {
		actions: {
			save: 'Telefon numarasını kaydet ve doğrula',
			update: 'Telefon numarasını güncelle ve doğrula'
		},
		fields: {
			phoneNumber: {
				promotion: {
					message: 'Hemen numaranı doğrula ve 5$ değerinde bedava kredi kazan.',
					note: 'Doğrulamadan 1 ay sonra süresi dolar'
				}
			}
		}
	},
	header: {
		title: 'Telefon numarası'
	}
})
